export default "__VITE_ASSET__jgIIVAuP__"